import React from 'react';
import { CommonContentLayout } from 'common/components/CommonContentLayout';
import { DashboardSubheader } from 'entities/Dashboard/components/DashboardSubheader';
import { DashboardBody } from 'entities/Dashboard/components/DashboardBody';

export const Dashboard: React.FC = () => {
  return <CommonContentLayout subheader={<DashboardSubheader />} body={<DashboardBody />} />;
};
